export default __webpack_public_path__ + "static/media/support.7729be9a.jpg";